import { useFileDownload } from '@/features/files';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/Avatar';
import { generateInitials, generateAvatarBackgroundColor } from '@/lib/utils';

interface CachedAvatarProps {
  fileId?: number | null;
  fallbackUrl?: string | null;
  userName: string;
  className?: string;
  alt?: string;
}

export const CachedAvatar = ({
  fileId,
  fallbackUrl,
  userName,
  className = 'h-10 w-10',
  alt,
}: CachedAvatarProps) => {
  const { data: avatarData } = useFileDownload(fileId);

  const avatarUrl = avatarData?.presignedUrl || fallbackUrl;

  return (
    <Avatar className={className}>
      <AvatarImage src={avatarUrl || undefined} alt={alt || userName} />
      <AvatarFallback
        style={{ backgroundColor: generateAvatarBackgroundColor(userName) }}
        className="text-white"
      >
        {generateInitials(userName)}
      </AvatarFallback>
    </Avatar>
  );
};
